import { isString, isUndefined } from "lodash-es";

export const DISPLAY_FORMAT_DATE = "DD MMM YYYY";
export const DISPLAY_FORMAT_TIME = "HH:mm";
export const DISPLAY_FORMAT_TIME_24 = "HH:mm";
export const DISPLAY_FORMAT_TIME_12 = "hh:mm A";

export const DISPLAY_FORMAT_PERIOD_DAY = "DD";

export type TDate = string; // ie. 2018-12-20
export type TDateTime = string; // ie. 2018-12-20T10:10:10Z

export const dateType = (defaultValue?: any) => (value?: any) =>
  isString(value) ? value : !isUndefined(defaultValue) ? defaultValue : null;

export const dateTimeType = dateType;
